module.exports = __webpack_public_path__ + "static/media/Display.6f15c220.ttf";